import { getConfigTenant, isCorpTenant } from "@capone/common";
import { useMemo } from "react";
import { PolicyTier, ProductType } from "redmond";
import { getIsDefaultPolicySelected, getIsDefaultPolicyForProduct } from "../utils/getIsDefaultPolicySelected"

export const useShowPolicyBanner = (policies?: PolicyTier, productType?: ProductType) => {
  if (!isCorpTenant(getConfigTenant())) return false;

  return useMemo(
    () =>
      productType
        ? !getIsDefaultPolicyForProduct(policies, productType)
        : !getIsDefaultPolicySelected(policies),
    [policies, productType]
  );
};
